import { defaultStoreUtils } from '@databases/redux';
import { type JiraIssueRef } from '@databases/types/confluence';
import { selectJiraIssueOptional } from '@databases/utils/redux/jira/selectors';
import React, { type FunctionComponent } from 'react';

const JiraIssueLabel: FunctionComponent<{ issue: JiraIssueRef }> = ({ issue }) => {
  const [resolvedIssue] = defaultStoreUtils.useShallowEqualSelector((state) => {
    return [selectJiraIssueOptional(state, issue)] as const;
  });

  return (
    <>{resolvedIssue ? `${resolvedIssue.key}: ${resolvedIssue.summary}` : issue.key}</>
  );
};

export default JiraIssueLabel;
